import React from 'react';
import './Records.css';

const consultationHistory = [
  { date: '2025-06-10', patient: 'John Doe', diagnosis: 'Hypertension', notes: 'Prescribed medication and advised lifestyle changes' },
  { date: '2025-06-14', patient: 'Sarah Lee', diagnosis: 'Migraine', notes: 'Advised MRI and pain management' },
];

const labReports = [
  { date: '2025-06-12', patient: 'John Doe', type: 'Blood Test', status: 'Reviewed', result: 'Normal' },
  { date: '2025-06-15', patient: 'Mark White', type: 'Chest X-Ray', status: 'Pending', result: '' },
];

const prescriptions = [
  { date: '2025-06-10', patient: 'John Doe', medicines: 'Amlodipine 5mg, Aspirin 75mg', duration: '30 days' },
  { date: '2025-06-14', patient: 'Sarah Lee', medicines: 'Sumatriptan 50mg', duration: 'As needed' },
];

const documents = [
  { fileName: 'John_Doe_Lab_Report.pdf', uploadedDate: '2025-06-12', patient: 'John Doe' },
  { fileName: 'MRI_SarahLee.jpg', uploadedDate: '2025-06-15', patient: 'Sarah Lee' },
];

const Records = () => {
  return (
    <div className="records-container">
      <h3>Medical Records</h3>

      {/* Patient Consultation History */}
      <div className="record-section">
        <h3>Patient Consultation History</h3>
        <table className="data-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Patient</th>
              <th>Diagnosis</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {consultationHistory.map((item, index) => (
              <tr key={index}>
                <td>{item.date}</td>
                <td>{item.patient}</td>
                <td>{item.diagnosis}</td>
                <td>{item.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Lab Reports */}
      <div className="record-section">
        <h3>Lab Reports</h3>
        <table className="data-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Patient</th>
              <th>Report Type</th>
              <th>Status</th>
              <th>Result</th>
            </tr>
          </thead>
          <tbody>
            {labReports.map((report, index) => (
              <tr key={index}>
                <td>{report.date}</td>
                <td>{report.patient}</td>
                <td>{report.type}</td>
                <td>{report.status}</td>
                <td>{report.result || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Prescriptions */}
      <div className="record-section">
        <h3>Prescriptions Issued</h3>
        <table className="data-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Patient</th>
              <th>Medicines</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            {prescriptions.map((rx, index) => (
              <tr key={index}>
                <td>{rx.date}</td>
                <td>{rx.patient}</td>
                <td>{rx.medicines}</td>
                <td>{rx.duration}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Uploaded Documents */}
      <div className="record-section">
        <h3>Uploaded Medical Documents</h3>
        <table className="data-table">
          <thead>
            <tr>
              <th>File</th>
              <th>Uploaded Date</th>
              <th>Patient</th>
            </tr>
          </thead>
          <tbody>
            {documents.map((doc, index) => (
              <tr key={index}>
                <td>{doc.fileName}</td>
                <td>{doc.uploadedDate}</td>
                <td>{doc.patient}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Records;
